import React, { useState, useEffect } from 'react';
import { api } from '../lib/api';
import clsx from 'clsx';
import { KontoBesedePopup } from './KontoSelector'; // [PATCH_OPISI_KONTO_PLUS_V1] popup Opisi za konte
import { Plus } from 'lucide-react'; // [PATCH_OPISI_KONTO_PLUS_V1]
import toast from 'react-hot-toast'; // [PATCH placano-fe v1]
import { jeIzdaniTip } from '../utils/docSmer';  // [PATCH izdani-doctype-fe v2]
import { iskanjeKontov, jeStevilcna } from '../lib/kontoIskanje'; // [PATCH konto-iskanje-naziv v1]

const fmt = (n: number) => { const x = Number(n||0).toFixed(2); const [c, d] = x.split('.'); return c.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + d; }; // [PATCH stevilke-locila v1] tisociska pika
function ZnesekInput({ value, onChange, className, id, tabIndex, title }: { value: number; onChange: (v: number) => void; className?: string; id?: string; tabIndex?: number; title?: string }) { // [PATCH izravnava-stroskov v1] opcijski title (tooltip)
  const [edit, setEdit] = useState(false);
  const [raw, setRaw] = useState('');
  const prikaz = edit ? raw : fmt(value); // [PATCH stevilke-locila v1] tisocice; raw med urejanjem gol
  return (
    <input id={id} tabIndex={tabIndex} title={title} type="text" inputMode="decimal" value={prikaz}
      onFocus={e => { setRaw(Number(value||0).toFixed(2).replace('.', ',')); setEdit(true); e.target.select(); }}
      onChange={e => setRaw(e.target.value)}
      onBlur={() => { let t = raw.replace(/\s/g, ''); if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.'); const n = Number(t); onChange(isNaN(n) ? 0 : n); setEdit(false); }} /* [PATCH stevilke-locila v1] pika = tisocica samo ob vejici */
      className={className}
    />
  );
}

// [PATCH rocni-vnos-fe v1] Tipkalni vnos konta: vpises stevilko, Tab/Enter potrdi.
// Predlogi iz kontnega plana; klik na predlog tudi potrdi.
// [PATCH konto-iskanje-naziv v1] Poizvedba brez crke isce po SIFRI (startsWith,
// cel plan, kot doslej), poizvedba s crko po NAZIVU (samo analiticni konti).
// Iskalni niz `q` je LOCEN od vrednosti `value`: dokler ni izbran veljaven konto,
// se v model (ai_posting_suggestion -> VOD/KN-21) ne zapise nic.
function KontoVnos({ value, konti, onCommit, tabIndex, id }: {
  value: string; konti: any[];
  onCommit: (konto: string, naziv: string) => void;
  tabIndex?: number; id?: string;
}) {
  const [q, setQ] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const prikaz = q !== null ? q : (value || '');
  // [PATCH konto-iskanje-naziv v1] Analiticni konti (>=4 mesta): SAMO ti gredo v
  // besedilne predloge. Sinteticni (npr. "754") ostanejo dosegljivi prek stevilcne
  // veje kot doslej -- knjizba nanje je racunovodska napaka, ki gre v VOD/KN-21.
  const analiticni = React.useMemo(
    () => konti.filter((k: any) => String(k?.code ?? '').length >= 4), [konti]);
  // [PATCH konto-iskanje-naziv v1] filtered in potrdi() gledata ISTI nabor in ISTI
  // limit, zato se ne more commitati nic, cesar uporabnik v seznamu ni videl.
  const filtered = React.useMemo(() => {
    const s = (q || '').trim();
    if (!s) return [];
    return jeStevilcna(s)
      ? iskanjeKontov(konti, s, 8)         // cel plan, limit 8 = kot doslej
      : iskanjeKontov(analiticni, s, 20);  // samo analiticni, limit 20
  }, [q, konti, analiticni]);
  const potrdi = () => {
    if (q === null) { setOpen(false); return; }
    const s = q.trim();
    if (!s) { onCommit('', ''); }
    else if (jeStevilcna(s)) {
      // [PATCH konto-iskanje-naziv v1] STEVILCNA VEJA: bitno enaka danasnji
      // (izvirne vrstice 44-48), vkljucno s predponskim samodopolnjevanjem
      // (zacne.length === 1) in nazivom iz plana. Edina razlika: nedigite pobere
      // replace tukaj, ne vec maska na vnosu.
      const stevke = s.replace(/[^0-9]/g, '');
      if (stevke) {
        const tocen = konti.find((k: any) => String(k.code) === stevke);
        const zacne = konti.filter((k: any) => String(k.code).startsWith(stevke));
        const t = tocen || (zacne.length === 1 ? zacne[0] : null);
        if (t) onCommit(String(t.code), String(t.name || ''));
        else onCommit(stevke, '');
      }
      // stevke === '' (vnos "..." / "--"): NIC se ne zapise, polje se povrne.
      // Doslej je masko pozrla ze na vnosu -> polje prazno -> konto se je POCISTIL.
      // Zavestna sprememba, dokumentirana v glavi lib/kontoIskanje.ts.
    } else {
      // [PATCH konto-iskanje-naziv v1] BESEDILNA VEJA: iskalni niz NI konto.
      // Zapise se samo nedvoumen zadetek iz ISTEGA seznama, ki ga uporabnik vidi,
      // in sicer k.name izbranega konta -- nikoli iskalni niz.
      if (filtered.length === 1) onCommit(String(filtered[0].code), String(filtered[0].name || ''));
    }
    setQ(null); setOpen(false);
  };
  return (
    <div className="relative">
      <input id={id} tabIndex={tabIndex} value={prikaz}
        onFocus={e => { setQ(value || ''); setOpen(true); setTimeout(() => e.target.select(), 0); }}
        onChange={e => { /* [PATCH konto-iskanje-naziv v1] maska [^0-9] odstranjena: brez nje ni mogoce iskati po nazivu */ setQ(e.target.value); setOpen(true); }}
        onBlur={() => setTimeout(potrdi, 120)}
        onKeyDown={e => {
          if (e.key === 'Escape') {
            // [PATCH konto-iskanje-naziv v1] preklic brez zapisa; prikaz se povrne
            // na `value`. stopPropagation je varovalka, ce detajl kdaj postane
            // modal z zapiranjem na Escape (danes globalnega handlerja ni).
            e.stopPropagation();
            setQ(null); setOpen(false);
            return;
          }
          if (e.key !== 'Enter') return;
          e.preventDefault();
          // [PATCH konto-iskanje-naziv v1] Pri BESEDILNEM iskanju Enter potrdi
          // SAMO nedvoumen zadetek. Ob 0 ali >1 zadetkih se ne zapise nic in polje
          // ostane odprto, da uporabnik poizvedbo zozi. Stevilcna raba je
          // nespremenjena: Enter sprozi blur -> potrdi().
          if (!jeStevilcna(q || '') && (q || '').trim() && filtered.length !== 1) return;
          (e.target as HTMLInputElement).blur();
        }}
        placeholder="konto"
        className="w-24 bg-gray-800 text-white text-xs rounded px-2 py-0.5 outline-none border border-gray-600 focus:border-blue-500 font-mono font-bold text-blue-400" />
      {open && filtered.length > 0 && (
        <div className="absolute left-0 top-7 w-[30rem] bg-gray-900 border border-gray-700 rounded-xl shadow-2xl z-[9999] max-h-64 overflow-y-auto">{/* [PATCH konto-dropdown-sirina v1] sirsi seznam + prelom naziva namesto odreza */}
          {filtered.map((k: any) => (
            <button key={k.code} onMouseDown={() => { onCommit(String(k.code), String(k.name || '')); setQ(null); setOpen(false); }}
              className="w-full text-left px-3 py-1.5 hover:bg-gray-800 flex gap-2">
              <span className="font-mono text-xs text-blue-400 w-16 shrink-0">{k.code}</span>
              <span className="text-xs text-gray-300 whitespace-normal break-words min-w-0">{k.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

// [PATCH razdeli-ddv-fe v1] + [PATCH razdeli-ddv-fe v3] (sumniki v nizih) --
// Simulacija parjenja stroskovna vrstica <-> DDV grupa, kot jo dela izvoz
// (backend/app/services/izvoz/opal.py, dokument_v_vod, korak 6).
// Namen: racunovodkinja izve ZE OB KONTIRANJU, ali bo prenos v VOD sel skozi,
// in dobi pomoc pri razrezu stroska po stopnjah DDV (STANJE_root 8.1, VIGRAD).
// Klasifikacija kontov je 1:1 z opal.py (_je_saldakonto = 220/221/280/285/919).
// Racunamo v CENTIH (cela stevila), da se izognemo plavajoci vejici.
// Meja: simulira SAMO parjenje zneskov, ne preslikave vrsta -> Vrsta_knjizbe.
const c2 = (n: any) => Math.round((Number(n) || 0) * 100);
const e2 = (c: number) => fmt(Number(c || 0) / 100); // [PATCH stevilke-locila v1] tisocice prek fmt
// [PATCH vod-saldakonto-280 v1] seznam MORA biti enak kot opal.py::_je_saldakonto
const jeSaldakontoFe = (k: any) => /^(220|221|280|285|919)/.test(String(k || ''));
const jeDdvKontoFe = (k: any) => /^(16|26)/.test(String(k || ''));
const jeStrosekFe = (kb: any) => !!kb && kb.tip === 'breme' && !kb.placano
  && !jeSaldakontoFe(kb.konto) && !jeDdvKontoFe(kb.konto);

// [PATCH izravnava-stroskov v1] vrstica je "strosek/odhodek" za samodejno izravnavo:
// konto skupine 4 ali 7 (zacne se s 4 ali 7), ne pa vrstica gumba "+ Placano".
// Namenoma NE zrcali opal.py klasifikacije (jeStrosekFe) - pravilo izravnave
// je poslovno: konti skupine 4 in 7 (zahteva Janeza, 28.07.2026).
const jeStrosek47 = (kb: any) => !!kb && !kb.placano && /^[47]/.test(String(kb.konto || ''));

interface DdvGrupa { vsota: number; enodelna: boolean; stopnja: number; osnova: number; }

// grupa = deli ene DDV vrstice (opal.py :992-1004):
// odbitna -> [osnova] (enodelna); neodbitna z DDV -> [osnova, DDV] (dvodelna)
const grupeIzDdv = (vrstice: any[]): DdvGrupa[] => (vrstice || []).map((v: any) => {
  const odb = v.odbitno !== false;
  const osnova = c2(v.osnova);
  const ddv = c2(v.znesek_ddv);
  const dvodelna = !odb && ddv > 0;
  return { vsota: osnova + (dvodelna ? ddv : 0), enodelna: !dvodelna,
           stopnja: Number(v.stopnja || 0), osnova };
});

// indeksi grup, ki jih EKSAKTNO pobere katera od podanih stroskovnih vrstic
const porabljeneGrupeFe = (stroski: any[], grupe: DdvGrupa[]): number[] => {
  const proste = grupe.map((_, j) => j);
  const porab: number[] = [];
  for (const kb of (stroski || [])) {
    const z = c2(kb.znesek);
    const p = proste.findIndex((j) => grupe[j].vsota === z);
    if (p >= 0) { porab.push(proste[p]); proste.splice(p, 1); }
  }
  return porab;
};

// Polna simulacija: eksaktno 1:1 -> razbitje ostanka -> drobiz 0,02 -> napaka.
// Sporocila so namenoma enaka tistim iz opal.py, da se ujemata UI in izvoz.
const simulirajVod = (knjizbe: any[], ddvVrstice: any[]): { ok: boolean; razlog?: string } => {
  const grupe = grupeIzDdv(ddvVrstice);
  const stroski = (knjizbe || []).filter(jeStrosekFe);
  if (grupe.length && !stroski.length) return { ok: false, razlog: 'DDV vrstice brez stroškovne knjižbe' };
  if (!grupe.length) return { ok: true };
  if (stroski.length === 1) {
    const vsota = grupe.reduce((s, g) => s + g.vsota, 0);
    const delta = c2(stroski[0].znesek) - vsota;
    if (Math.abs(delta) > 5) {
      return { ok: false, razlog: 'osnove (' + e2(vsota) + ') se ne ujemajo s stroškovno vrstico '
        + stroski[0].konto + ' (' + e2(c2(stroski[0].znesek)) + ')' };
    }
    return { ok: true };
  }
  const proste = grupe.map((_, j) => j);
  let ostanek: any[] = [];
  for (const kb of stroski) {
    const z = c2(kb.znesek);
    const p = proste.findIndex((j) => grupe[j].vsota === z);
    if (p < 0) { if (Math.abs(z) > 5) ostanek.push(kb); continue; }
    proste.splice(p, 1);
  }
  if (ostanek.length && proste.length === 1 && grupe[proste[0]].enodelna) {
    const vs = ostanek.reduce((s, k) => s + c2(k.znesek), 0);
    if (Math.abs(vs - grupe[proste[0]].vsota) <= 5) { proste.splice(0, 1); ostanek = []; }
  }
  if (ostanek.length) {
    const nov: any[] = [];
    for (const kb of ostanek) {
      const z = c2(kb.znesek);
      let best: number | null = null;
      for (const j of proste) {
        if (!grupe[j].enodelna) continue;
        if (best === null || Math.abs(grupe[j].vsota - z) < Math.abs(grupe[best].vsota - z)) best = j;
      }
      if (best !== null && Math.abs(grupe[best].vsota - z) <= 2) proste.splice(proste.indexOf(best), 1);
      else nov.push(kb);
    }
    ostanek = nov;
  }
  if (ostanek.length) {
    return { ok: false, razlog: 'za ' + ostanek[0].konto + ' (' + e2(c2(ostanek[0].znesek))
      + ') ni enolične DDV grupe' };
  }
  if (proste.length) return { ok: false, razlog: 'DDV grupa brez pripadajoče stroškovne vrstice' };
  return { ok: true };
};

interface Knjizba {
  tip: 'breme' | 'dobro';
  konto: string;
  naziv: string;
  znesek: number;
  sm?: string;
  projekt?: string; // [PATCH projekti-sifrant v1] VOD <Analitika6>
  requires_cost_center?: boolean;
  je_saldakonto?: boolean;  // [PATCH saldakonto-partner v1] konto zahteva partnerja
  placano?: boolean;        // [PATCH placano-fe v1] vrstica iz gumba "+ Placano"
  partner_id?: string;      // [PATCH placano-fe v1] placnik (delavec) na DOBRO vrstici
  partner_naziv?: string;   // [PATCH placano-fe v1]
}

export function KontiranjeEditor({ knjizbe, companyId, onChange, tabVnos, ddvVrstice, docType, docPartnerId, docPartnerNaziv }: {
  knjizbe: Knjizba[];
  companyId: string;
  onChange: (knjizbe: Knjizba[]) => void;
  tabVnos?: boolean; // [PATCH rocni-vnos-fe v1]
  ddvVrstice?: any[]; // [PATCH razdeli-ddv-fe v1] = kontiranje.ddv_knjiga
  docType?: string; // [PATCH razdeli-ddv-pogoji v1] doc_type dokumenta; izdani racuni brez gumba Razdeli in brez statusa
  docPartnerId?: string; // [PATCH saldakonto-partner v1] partner dokumenta za predizpolnitev saldakontnih vrstic
  docPartnerNaziv?: string; // [PATCH saldakonto-partner v2] naziv iz glave; seznam partnerjev je odrezan na 5000
}) {
  const [smSeznam, setSmSeznam] = useState<any[]>([]);
  const [smKonti, setSmKonti] = useState<Set<string>>(new Set());
  const [saldaKonti, setSaldaKonti] = useState<Set<string>>(new Set()); // [PATCH saldakonto-partner v1]
  const [prevDocPartner, setPrevDocPartner] = useState<string | undefined>(undefined); // [PATCH saldakonto-partner v2]
  const [smPredlog, setSmPredlog] = useState<Record<string, string>>({});
  const [projSeznam, setProjSeznam] = useState<any[]>([]); // [PATCH projekti-sifrant v1]
  const [kontiList, setKontiList] = useState<any[]>([]); // [PATCH rocni-vnos-fe v1]
  const [opisiKonto, setOpisiKonto] = useState<string | null>(null); // [PATCH_OPISI_KONTO_PLUS_V1] konto za popup Opisov
  const [placnikDelavec, setPlacnikDelavec] = useState<any>({}); // [PATCH placano-fe v1] privzeti konto+placnik iz profila
  const [placnikDelavecIzd, setPlacnikDelavecIzd] = useState<any>({}); // [PATCH placano-izdani-fe v1] izdani: privzeti konto+prejemnik iz profila
  const [izvozProgram, setIzvozProgram] = useState<string>(''); // [PATCH razdeli-ddv-pogoji v1] iz profila; funkcija samo pri 'opal'
  const [partnerjiSeznam, setPartnerjiSeznam] = useState<any[]>([]); // [PATCH placano-fe v1] za rocno menjavo placnika
  useEffect(() => {
    if (companyId) {
      api.get(`/sifranti/sm/${companyId}`).then(r => setSmSeznam(r.data)).catch(() => {});
      api.get(`/sifranti/projekti/${companyId}`).then(r => setProjSeznam(r.data)).catch(() => {}); // [PATCH projekti-sifrant v1]
      api.get(`/profil/${companyId}`).then(r => { setPlacnikDelavec(r.data?.placnik_delavec || {}); setPlacnikDelavecIzd(r.data?.placnik_delavec_izdani || {}); setIzvozProgram(String(r.data?.izvoz_program || '')); }).catch(() => {}); // [PATCH placano-fe v1] + [PATCH razdeli-ddv-pogoji v1] izvoz_program za Opal pogoj + [PATCH placano-izdani-fe v1]
      api.get(`/sifranti/partnerji/${companyId}?limit=5000`).then(r => setPartnerjiSeznam(r.data || [])).catch(() => {}); // [PATCH placano-fe v1]
      api.get(`/sifranti/kontni-plan/${companyId}`).then(r => {
        setKontiList(r.data || []); // [PATCH rocni-vnos-fe v1]
        const sm = new Set<string>(r.data.filter((k: any) => k.requires_cost_center).map((k: any) => String(k.code)));
        setSmKonti(sm);
        // [PATCH saldakonto-partner v1] isti odgovor, brez dodatnega prometa
        setSaldaKonti(new Set<string>(r.data.filter((k: any) => k.je_saldakonto).map((k: any) => String(k.code))));
        const predlog: Record<string, string> = {};
        r.data.forEach((k: any) => { if (k.suggested_cost_center) predlog[String(k.code)] = String(k.suggested_cost_center); });
        setSmPredlog(predlog);
      }).catch(() => {});
    }
  }, [companyId]);
  // konto je stroskovnomesten ce ima zastavico ALI je v seznamu stroskovnomestnih kontov
  const jeSmKonto = (k: any) => k.requires_cost_center || smKonti.has(String(k.konto));
  // [PATCH saldakonto-partner v1] ogledalno jeSmKonto
  const jeSaldaKonto = (k: any) => k.je_saldakonto || saldaKonti.has(String(k.konto));
  // [PATCH placnik-saldakonto-pogoj v1] Vrstica je "placnik iz profila" SAMO, kadar
  // nosi zastavico placano IN sedi na kontu iz profila ("Racun = placan").
  // Prej je zadoscala gola zastavica placano, zato sta se izbirnik in trda blokada
  // pojavila tudi na 165002 (kartica) in 109000 (denar na poti) -- v sifrantu NISTA
  // saldakonta -- medtem ko 230000 (avans, kljukica t) partnerja sploh ni dobil.
  // Zastavice placano ne odstranjujemo: uvoz_vod/parser.py jo postavlja namenoma,
  // izvoz/opal.py jo bere za Ne_gre_v_knjigo.
  // Prazen profilni konto pomeni, da te veje ni (izdani: placnik_delavec_izdani = {}).
  const jePlacnikProfil = (k: any) => {
    const pk = String((((jeIzdaniTip(docType) ? placnikDelavecIzd : placnikDelavec) || {}) as any).konto || '').trim();
    return !!k.placano && !!pk && String(k.konto || '').trim() === pk;
  };
  // SM stolpec skrijemo, ce podjetje nima SM kontov (npr. vodi_sm=false)
  const prikaziSm = smKonti.size > 0;
  // [PATCH projekti-sifrant v1] stolpec Projekt le, ce ima podjetje projekte
  const prikaziProjekt = prikaziSm && projSeznam.length > 0;
  // [PATCH projekti-sifrant v1] backfill: obstojecim knjizbam s SM brez
  // projekta zapisemo projekt = SM (Ziri praksa), da UI prikaz = VOD izvoz.
  useEffect(() => {
    if (!prikaziProjekt) return;
    if (knjizbe.some(k => k.sm && !k.projekt)) {
      onChange(knjizbe.map(k => (k.sm && !k.projekt) ? { ...k, projekt: k.sm } : k));
    }
  }, [prikaziProjekt, knjizbe]);
  // [PATCH saldakonto-partner v2] Predizpolnitev + sledenje glavi. Dva primera:
  //  a) saldakontna vrstica BREZ partnerja -> dobi partnerja iz glave;
  //  b) vrstica, ki nosi partnerja, KI JE BIL DOSLEJ V GLAVI -> se premakne z njim.
  // Rocno izbran partner in vrstice iz "+ Placano" ostanejo NEDOTAKNJENI.
  // Naziv primarno iz glave (docPartnerNaziv): seznam partnerjev je strezniško
  // odrezan na 5000 (sifranti.py get_partnerji), zato pri velikih sifrantih
  // partnerja v njem ni. Brez naziva ne zapisemo nicesar (prazno polje bi zavajalo).
  useEffect(() => {
    if (!docPartnerId || saldaKonti.size === 0) return;
    const dp = partnerjiSeznam.find((p: any) => String(p.id) === String(docPartnerId));
    const naziv = String(docPartnerNaziv || '').trim() || String((dp && dp.name) || '');
    if (!naziv) return;
    const prej = prevDocPartner;
    const seZamenjal = !!prej && String(prej) !== String(docPartnerId);
    const cilj = (k: Knjizba) => !jePlacnikProfil(k) && jeSaldaKonto(k) && !!k.konto && (  // [PATCH placnik-saldakonto-pogoj v1]
      !k.partner_id || (seZamenjal && String(k.partner_id) === String(prej)));
    if (knjizbe.some(cilj)) {
      onChange(knjizbe.map(k => cilj(k)
        ? { ...k, partner_id: String(docPartnerId), partner_naziv: naziv } : k));
    }
    if (String(prej || '') !== String(docPartnerId)) setPrevDocPartner(String(docPartnerId));
  }, [docPartnerId, docPartnerNaziv, saldaKonti, partnerjiSeznam, knjizbe, prevDocPartner]);
  const aktiva = knjizbe.filter(k => k.tip === 'breme').reduce((s, k) => s + Number(k.znesek), 0);
  const pasiva = knjizbe.filter(k => k.tip === 'dobro').reduce((s, k) => s + Number(k.znesek), 0);
  const razlika = Math.abs(aktiva - pasiva);
  const uravnotezeno = razlika < 0.01;
  // [PATCH rocni-vnos-fe v1] indeksa za tab-verigo (dobro / strosek = prva ne-16 breme)
  const idxDobro = knjizbe.findIndex(k => k.tip === 'dobro');
  const idxStrosek = knjizbe.findIndex(k => k.tip === 'breme' && !String(k.konto || '').startsWith('16'));

  const updateKnjizba = (i: number, changes: Partial<Knjizba>) => {
    const nove = [...knjizbe];
    nove[i] = { ...nove[i], ...changes };
    onChange(nove);
  };

  // [PATCH izravnava-stroskov v1] Samodejna izravnava stroskovnih vrstic.
  // Ob spremembi zneska vrstice s kontom skupine 4/7 (in vsaj se eno drugo
  // tako vrstico) se ZADNJA druga stroskovna vrstica nastavi tako, da je
  // vsota AKTIVA = vsota PASIVA. Velja SAMO za prejete racune (docType).
  // Ce je urejeni znesek vecji od pokritja, gre predlog izravnave na 0,00
  // (v2; prej brez izravnave). Racunamo v centih kot simulirajVod.
  // Izravnana vrstica dobi oranzno polje zneska + tooltip; oznaka izgine, ko
  // se vrstica spremeni ali ne ustreza vec (npr. menjava dokumenta).
  const [izravnano, setIzravnano] = useState<{ i: number; cent: number } | null>(null);
  useEffect(() => {
    if (!izravnano) return;
    const k = knjizbe[izravnano.i];
    if (!k || !jeStrosek47(k) || c2(k.znesek) !== izravnano.cent) setIzravnano(null);
  }, [knjizbe, izravnano]);
  const spremeniZnesek = (i: number, v: number) => {
    const nove = [...knjizbe];
    nove[i] = { ...nove[i], znesek: v };
    if (!jeIzdaniTip(docType) && jeStrosek47(nove[i])) {
      const drugi: number[] = [];
      nove.forEach((kb, x) => { if (x !== i && jeStrosek47(kb)) drugi.push(x); });
      if (drugi.length >= 1) {
        const cilj = drugi[drugi.length - 1];
        let breme = 0, dobro = 0;
        nove.forEach((kb, x) => {
          if (x === cilj) return;
          if (kb.tip === 'dobro') dobro += c2(kb.znesek); else breme += c2(kb.znesek);
        });
        const nov0 = nove[cilj].tip === 'dobro' ? breme - dobro : dobro - breme;
        // [PATCH izravnava-stroskov v2] znesek vecji od pokritja -> predlog 0,00
        // (prej: brez izravnave); vrstica se vseeno oznaci rumeno.
        const nov = nov0 < 0 ? 0 : nov0;
        if (nov !== c2(nove[cilj].znesek)) {
          nove[cilj] = { ...nove[cilj], znesek: nov / 100 };
          setIzravnano({ i: cilj, cent: nov });
        }
      }
    }
    onChange(nove);
  };

  // [PATCH razdeli-ddv-fe v1] razrez stroskovne vrstice po stopnjah DDV
  const [razrezIdx, setRazrezIdx] = useState<number | null>(null);
  const [razrezGrupa, setRazrezGrupa] = useState<number>(0);
  const [razrezZnesek, setRazrezZnesek] = useState<number>(0);
  // KIR / samoobdavcitev: opal._KIR_VRSTE ni bil pregledan -> funkcijo skrijemo
  // [PATCH razdeli-ddv-pogoji v1] gumb Razdeli in status SAMO za Opal stranke
  // (izvoz_program === 'opal'; Vasco in drugi: skrito) in SAMO na prejetih
  // dokumentih. Izdani: backend razbija prihodke po postavkah in VOD izdanih
  // pari po stopnji - simulacija prejete poti tam ne velja (lazni alarm).
  const ddvNaVoljo = izvozProgram === 'opal' && !jeIzdaniTip(docType)
    && Array.isArray(ddvVrstice) && ddvVrstice.length > 0
    && !ddvVrstice.some((v: any) => /KIR/i.test(String((v && v.vrsta) || '')));
  const vodGrupe: DdvGrupa[] = ddvNaVoljo ? grupeIzDdv(ddvVrstice as any[]) : [];
  // [PATCH razdeli-ddv-pogoji v1] statusna vrstica (opozorilo) samo, kadar sta
  // izpolnjena OBA pogoja: vsaj 2 razlicni stopnji DDV na racunu IN vsaj 2
  // razlicna stroskovna konta skupine 4 ali 7 med breme vrsticami.
  const razlicneStopnje = new Set(((ddvVrstice || []) as any[]).map((v: any) => Number(v.stopnja || 0))).size;
  const razlicniKonti47 = new Set((knjizbe || []).filter((kb: any) => jeStrosekFe(kb) && /^[47]/.test(String(kb.konto || ''))).map((kb: any) => String(kb.konto))).size;
  const vodStatus = (ddvNaVoljo && razlicneStopnje >= 2 && razlicniKonti47 >= 2) ? simulirajVod(knjizbe, ddvVrstice as any[]) : null;

  // prosta osnova grupe j, gledano BREZ vrstice i (tiste, ki jo razrezujemo)
  const prostoZaGrupo = (i: number, j: number): number => {
    const drugi = knjizbe.filter((kb, idx) => idx !== i && jeStrosekFe(kb));
    return porabljeneGrupeFe(drugi, vodGrupe).indexOf(j) >= 0 ? 0 : (vodGrupe[j] ? vodGrupe[j].vsota : 0);
  };

  const odpriRazrez = (i: number) => {
    const z = c2(knjizbe[i] && knjizbe[i].znesek);
    let j = vodGrupe.findIndex((_, x) => prostoZaGrupo(i, x) > 0 && prostoZaGrupo(i, x) < z);
    if (j < 0) j = 0;
    setRazrezIdx(i);
    setRazrezGrupa(j);
    setRazrezZnesek(Math.min(z, prostoZaGrupo(i, j) || (vodGrupe[j] ? vodGrupe[j].vsota : 0)) / 100);
  };

  // hipoteticni nabor knjizb po razrezu (za ziv predogled in za izvedbo)
  const razrezNabor = (i: number, del: number): Knjizba[] | null => {
    const cel = c2(knjizbe[i] && knjizbe[i].znesek);
    if (!(del > 0) || del >= cel) return null;
    const izvor = knjizbe[i];
    const nove = [...knjizbe];
    nove[i] = { ...izvor, znesek: del / 100 };
    nove.splice(i + 1, 0, { ...izvor, znesek: (cel - del) / 100 });
    return nove;
  };

  const razrezPredogled = (i: number) => {
    if (!ddvNaVoljo) return null;
    const nabor = razrezNabor(i, c2(razrezZnesek));
    return nabor ? simulirajVod(nabor, ddvVrstice as any[]) : null;
  };

  const izvediRazrez = (i: number) => {
    const nabor = razrezNabor(i, c2(razrezZnesek));
    if (!nabor) { toast.error('Znesek razreza mora biti večji od 0 in manjši od zneska vrstice.'); return; }
    setRazrezIdx(null);
    onChange(nabor);
  };

  const dodajKnjizbo = (tip: 'breme' | 'dobro') => {
    const preostanekBreme = pasiva - aktiva;
    const preostanekDobro = aktiva - pasiva;
    const predlaganiZnesek = tip === 'breme' && preostanekBreme > 0 ? preostanekBreme :
                             tip === 'dobro' && preostanekDobro > 0 ? preostanekDobro : 0;
    // [PATCH razdeli-ddv-fe v4] nova BREME vrstica podeduje SM in projekt s prve
    // obstojece stroskovne vrstice dokumenta ("kot je na racunu"). Ce te ni,
    // ostane prazno in velja predlog iz kontnega plana (smPredlog).
    const izvorDim: any = tip === 'breme'
      ? knjizbe.find(kb => jeStrosekFe(kb) && (kb.sm || kb.projekt))
      : undefined;
    onChange([...knjizbe, { tip, konto: '', naziv: '', znesek: predlaganiZnesek,
      ...(izvorDim && izvorDim.sm ? { sm: izvorDim.sm } : {}),
      ...(izvorDim && izvorDim.projekt ? { projekt: izvorDim.projekt } : {}) }]);
  };

  // [PATCH placano-fe v1] "+ Placano": zapre obveznost do dobavitelja (BREME na kontu
  // prve DOBRO vrstice) in jo za isti znesek prenese na placnika-delavca (DOBRO na
  // kontu iz profila podjetja). Vrstici sta rocno popravljivi in izbrisljivi (x).
  const dodajPlacano = () => {
    // [PATCH placano-izdani-fe v1] vejitev po smeri: IZDANI zapre TERJATEV
    // (prva BREME, npr. 1200 -> DOBRO isti znesek) in prenese na konto +
    // prejemnika iz profila (placnik_delavec_izdani) na BREME. Prejeta smer
    // je IDENTICNA dosedanji.
    const izdPl = jeIzdaniTip(docType);
    const prva = knjizbe.find(k => k.tip === (izdPl ? 'breme' : 'dobro'));
    const z = Number(prva?.znesek || 0);
    if (!prva || !(z > 0)) { toast.error(izdPl ? 'Ni BREME vrstice (terjatve) z zneskom — "+ Plačano" nima kaj prenesti.' : 'Ni DOBRO vrstice z zneskom — "+ Plačano" nima kaj prenesti.'); return; }
    const pd: any = (izdPl ? placnikDelavecIzd : placnikDelavec) || {};
    onChange([...knjizbe,
      { tip: izdPl ? 'dobro' : 'breme', konto: prva.konto, naziv: prva.naziv, znesek: z, placano: true },
      { tip: izdPl ? 'breme' : 'dobro', konto: pd.konto || '', naziv: pd.konto_naziv || '', znesek: z, placano: true,
        partner_id: pd.partner_id || undefined, partner_naziv: pd.partner_naziv || undefined },
    ]);
  };

  const odstraniKnjizbo = (i: number) => {
    if (knjizbe.length <= 2) return;
    onChange(knjizbe.filter((_, idx) => idx !== i));
  };

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-700 overflow-visible">
      <table className="w-full text-xs">
        <thead className="bg-gray-50 dark:bg-gray-800">
          <tr>
            <th className="px-3 py-2 text-left text-gray-500 w-20">Tip</th>
            <th className="px-3 py-2 text-left text-gray-500 w-32">Konto</th>
            <th className="px-3 py-2 text-left text-gray-500">Naziv</th>
            {prikaziSm && (<th className="px-3 py-2 text-left text-gray-500 w-28">SM</th>)}
            {prikaziProjekt && (<th className="px-3 py-2 text-left text-gray-500 w-32">Projekt</th>)}{/* [PATCH projekti-sifrant v1] */}
            <th className="px-3 py-2 text-right text-blue-500 font-semibold">AKTIVA</th>
            <th className="px-3 py-2 text-right text-green-500 font-semibold">PASIVA</th>
            <th className="px-1 py-2 w-14"></th>{/* [PATCH razdeli-ddv-fe v1] */}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100 dark:divide-gray-800">
          {knjizbe.map((k, i) => (
            <tr key={i} className={(k as any)._avans_link ? "bg-indigo-50 dark:bg-indigo-950/40" : "bg-white dark:bg-gray-900"} title={(k as any)._avans_link ? "Storno avansa" : undefined}>
              <td className="px-3 py-1.5">
                <select tabIndex={tabVnos ? -1 : undefined} value={k.tip} onChange={e => updateKnjizba(i, {tip: e.target.value as 'breme'|'dobro'})}
                  className="bg-gray-800 text-xs rounded px-1 py-0.5 outline-none border border-gray-600 text-white">
                  <option value="breme">BREME</option>
                  <option value="dobro">DOBRO</option>
                </select>
              </td>
              <td className="px-3 py-1.5">
                <div className="flex items-center gap-1">{/* [PATCH_OPISI_KONTO_PLUS_V1] */}
                <KontoVnos
                  id={tabVnos ? (i === idxDobro ? 'kv-dobro-konto' : (i === idxStrosek ? 'kv-breme-konto' : undefined)) : undefined}
                  tabIndex={tabVnos ? (i === idxDobro ? 13 : (i === idxStrosek ? 14 : (String(k.konto || '').startsWith('16') ? -1 : 0))) : undefined}
                  value={k.konto} konti={kontiList}
                  onCommit={(konto, naziv) => { const rcc = smKonti.has(String(konto)); const jsk = saldaKonti.has(String(konto)); /* [PATCH saldakonto-partner v1] */ updateKnjizba(i, {konto, naziv: naziv || k.naziv, requires_cost_center: rcc, sm: rcc ? k.sm : undefined, projekt: rcc ? k.projekt : undefined, je_saldakonto: jsk, ...((jsk || k.placano) ? {} : {partner_id: undefined, partner_naziv: undefined})}); }}
                />
                {k.konto ? (
                  <button type="button" tabIndex={-1} title="Opisi za ta konto" onClick={() => setOpisiKonto(String(k.konto))}
                    className="w-5 h-5 flex items-center justify-center rounded border border-blue-500/40 text-blue-400 hover:bg-blue-600/40 transition flex-shrink-0">
                    <Plus className="w-3 h-3"/>
                  </button>
                ) : null}
                </div>
              </td>
              <td className="px-3 py-1.5 text-gray-500 text-xs">{k.naziv}
                {jePlacnikProfil(k) && (  /* [PATCH placnik-saldakonto-pogoj v1] prej: k.placano && k.tip === ... */
                  <PlacnikVrstica partnerId={k.partner_id} partnerNaziv={k.partner_naziv} partnerji={partnerjiSeznam}
                    companyId={companyId /* [PATCH saldakonto-partner v2] */}
                    onIzbira={(pid, pnaz) => updateKnjizba(i, { partner_id: pid, partner_naziv: pnaz })} />
                )}{/* [PATCH placano-fe v1] */}
                {!jePlacnikProfil(k) && jeSaldaKonto(k) && (  /* [PATCH placnik-saldakonto-pogoj v1] prej: !k.placano && ... */
                  <PlacnikVrstica partnerId={k.partner_id} partnerNaziv={k.partner_naziv} partnerji={partnerjiSeznam}
                    placeholder="partner (saldakonto)..." companyId={companyId}
                    onIzbira={(pid, pnaz) => updateKnjizba(i, { partner_id: pid, partner_naziv: pnaz })} />
                )}{/* [PATCH saldakonto-partner v1] */}
                {/* [PATCH razdeli-ddv-fe v1] plosca razreza po stopnjah DDV */}
                {razrezIdx === i && ddvNaVoljo && (
                  <div className="mt-1 p-2 rounded-lg border border-blue-500/50 bg-blue-900/20 space-y-1">
                    <div className="flex items-center gap-2 flex-wrap">
                      <select value={razrezGrupa}
                        onChange={e => { const j = Number(e.target.value); setRazrezGrupa(j);
                          setRazrezZnesek(Math.min(c2(k.znesek), prostoZaGrupo(i, j) || (vodGrupe[j] ? vodGrupe[j].vsota : 0)) / 100); }}
                        className="text-xs rounded px-1 py-0.5 bg-gray-800 text-white border border-gray-600">
                        {vodGrupe.map((g, j) => (
                          <option key={j} value={j}>
                            {String(g.stopnja).replace('.', ',')}% — osnova {e2(g.vsota)} (prosto {e2(prostoZaGrupo(i, j))})
                          </option>
                        ))}
                      </select>
                      <ZnesekInput value={razrezZnesek} onChange={v => setRazrezZnesek(v)}
                        className="w-24 bg-gray-800 text-white text-xs rounded px-2 py-0.5 outline-none border border-gray-600 text-right font-mono font-bold text-blue-400" />
                      <span className="text-gray-400">ostane {e2(Math.max(0, c2(k.znesek) - c2(razrezZnesek)))}</span>
                    </div>
                    {(() => { const pr = razrezPredogled(i); return pr ? (
                      <div className={clsx('text-xs', pr.ok ? 'text-green-500' : 'text-amber-500')}>
                        {pr.ok ? '✓ po razrezu bo prenos v redu' : '⚠ po razrezu: ' + pr.razlog}
                      </div>
                    ) : (
                      <div className="text-xs text-amber-500">⚠ znesek mora biti med 0 in {e2(c2(k.znesek))}</div>
                    ); })()}
                    <div className="flex items-center gap-2">
                      <button type="button" onClick={() => izvediRazrez(i)}
                        className="text-xs px-2 py-0.5 rounded bg-blue-600 hover:bg-blue-700 text-white">Razdeli</button>
                      <button type="button" onClick={() => setRazrezIdx(null)}
                        className="text-xs px-2 py-0.5 rounded border border-gray-600 text-gray-300 hover:bg-gray-800">Prekliči</button>
                    </div>
                    <div className="text-[10px] text-amber-500">
                      Sistem pari po ZNESKIH, ne po vsebini — razrez preveri po postavkah računa.
                    </div>
                  </div>
                )}
              </td>
              {prikaziSm && (
              <td className="px-3 py-1.5">
                {jeSmKonto(k) ? (
                  <select id={tabVnos && i === idxStrosek ? 'kv-breme-sm' : undefined} tabIndex={tabVnos ? (i === idxStrosek ? 15 : -1) : undefined} value={k.sm || smPredlog[String(k.konto)] || ''} onChange={e => { const v = e.target.value; updateKnjizba(i, {sm: v, projekt: (!k.projekt || k.projekt === k.sm) ? (v || undefined) : k.projekt}); }}
                    /* [PATCH razdeli-ddv-fe v4] ozji izbirnik SM; razsiri se SAMO, kadar ima izbrano SM dolg naziv */
                    className={clsx('text-xs rounded px-1 py-0.5 outline-none border bg-gray-800 text-white',
                      ((smSeznam.find(s => String(s.code) === String(k.sm || smPredlog[String(k.konto)] || ''))?.name || '').length > 16) ? 'w-56' : 'w-28',
                      (k.sm || smPredlog[String(k.konto)]) ? 'border-gray-600' : 'border-red-500')}>
                    <option value="">— izberi SM —</option>
                    {smSeznam.map(sm => <option key={sm.code} value={sm.code}>{sm.code} {sm.name}</option>)}
                  </select>
                ) : <span className="text-gray-600 text-xs">—</span>}
              </td>
              )}
              {prikaziProjekt && (
              <td className="px-3 py-1.5">{/* [PATCH projekti-sifrant v1] */}
                {jeSmKonto(k) ? (
                  <select tabIndex={tabVnos ? -1 : undefined} value={k.projekt || ''} onChange={e => updateKnjizba(i, {projekt: e.target.value || undefined})}
                    className={clsx('text-xs rounded px-1 py-0.5 outline-none border bg-gray-800 text-white', k.projekt ? 'border-gray-600' : 'border-red-500')}>
                    <option value="">— izberi projekt —</option>
                    {projSeznam.map(p => <option key={p.code} value={p.code}>{p.code} {p.name}</option>)}
                  </select>
                ) : <span className="text-gray-600 text-xs">—</span>}
              </td>
              )}
              <td className="px-3 py-1.5 text-right">
                {k.tip === 'breme' ? (
                  <ZnesekInput value={k.znesek} onChange={v => spremeniZnesek(i, v)} /* [PATCH izravnava-stroskov v1] */
                    id={tabVnos && i === idxStrosek ? 'kv-breme-znesek' : undefined}
                    tabIndex={tabVnos ? (i === idxStrosek ? 16 : (String(k.konto || '').startsWith('16') ? -1 : 0)) : undefined} /* [PATCH rocni-vnos-fe v2] */
                    title={izravnano && izravnano.i === i ? 'Samodejno izravnano' : undefined}
                    className={clsx('w-24 text-xs rounded px-2 py-0.5 outline-none border text-right font-mono font-bold',
                      izravnano && izravnano.i === i
                        ? 'bg-amber-400 border-amber-600 text-gray-900' /* [PATCH izravnava-stroskov v2] polna barva - vidno tudi na svetli temi */
                        : 'bg-gray-800 text-white border-gray-600 text-blue-400')}
                  />
                ) : <span className="text-gray-300">—</span>}
              </td>
              <td className="px-3 py-1.5 text-right">
                {k.tip === 'dobro' ? (
                  <ZnesekInput value={k.znesek} onChange={v => spremeniZnesek(i, v)} /* [PATCH izravnava-stroskov v1] */
                    tabIndex={tabVnos ? -1 : undefined}
                    title={izravnano && izravnano.i === i ? 'Samodejno izravnano' : undefined}
                    className={clsx('w-24 text-xs rounded px-2 py-0.5 outline-none border text-right font-mono font-bold',
                      izravnano && izravnano.i === i
                        ? 'bg-amber-400 border-amber-600 text-gray-900' /* [PATCH izravnava-stroskov v2] polna barva - vidno tudi na svetli temi */
                        : 'bg-gray-800 text-white border-gray-600 text-green-400')}
                  />
                ) : <span className="text-gray-300">—</span>}
              </td>
              <td className="px-1 py-1.5">
                {/* [PATCH razdeli-ddv-fe v4] gumba v isti obliki kot "+" pri kontu (w-5 h-5) */}
                <div className="flex items-center justify-center gap-1">
                {ddvNaVoljo && jeStrosekFe(k) && (
                  <button type="button" tabIndex={-1} title="Razdeli vrstico po stopnjah DDV"
                    onClick={() => (razrezIdx === i ? setRazrezIdx(null) : odpriRazrez(i))}
                    className="w-5 h-5 flex items-center justify-center rounded border border-blue-500/40 text-blue-400 hover:bg-blue-600/40 transition flex-shrink-0 text-xs leading-none">÷</button>
                )}
                <button type="button" tabIndex={tabVnos ? -1 : undefined} title="Odstrani vrstico" onClick={() => odstraniKnjizbo(i)}
                  className="w-5 h-5 flex items-center justify-center rounded border border-red-500/40 text-red-400 hover:bg-red-600/40 transition flex-shrink-0 text-xs leading-none">×</button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot className="bg-gray-50 dark:bg-gray-800 border-t-2 border-gray-300 dark:border-gray-600">
          <tr>
            <td className="px-3 py-1.5 flex gap-2 w-20">
              <button tabIndex={tabVnos ? -1 : undefined} onClick={() => dodajKnjizbo('breme')} className="text-xs text-blue-400 hover:text-blue-300">+ Breme</button>
              <span className="text-gray-600">|</span>
              <button tabIndex={tabVnos ? -1 : undefined} onClick={() => dodajKnjizbo('dobro')} className="text-xs text-green-400 hover:text-green-300">+ Dobro</button>
              <span className="text-gray-600">|</span>{/* [PATCH placano-fe v1] */}
              <button tabIndex={tabVnos ? -1 : undefined} onClick={dodajPlacano} className="text-xs text-red-400 hover:text-red-300">+ Plačano</button>{/* [PATCH placano-gumb v1.1] brez whitespace-nowrap -> "+" zgoraj, "Placano" spodaj */}
            </td>
            <td className="px-3 py-1.5 w-32"></td>
            <td className={prikaziSm ? "px-3 py-1.5" : "px-3 py-1.5 text-xs font-bold text-gray-500 text-right"}>{prikaziSm ? "" : "SKUPAJ"}</td>
            {prikaziSm && (<td className="px-3 py-1.5 text-xs font-bold text-gray-500 text-right">SKUPAJ</td>)}
            {prikaziProjekt && (<td className="px-3 py-1.5"></td>)}{/* [PATCH projekti-sifrant v1] */}
            <td className={clsx('px-3 py-1.5 text-right font-mono font-bold text-sm', uravnotezeno ? 'text-blue-600' : 'text-red-500')}>
              {fmt(aktiva)}
            </td>
            <td className={clsx('px-3 py-1.5 text-right font-mono font-bold text-sm', uravnotezeno ? 'text-green-600' : 'text-red-500')}>
              {fmt(pasiva)}
            </td>
            <td className="w-14"></td>{/* [PATCH razdeli-ddv-fe v1] */}
          </tr>
          {!uravnotezeno && (
            <tr>
              <td colSpan={(prikaziSm ? 7 : 6) + (prikaziProjekt ? 1 : 0)} className="px-3 py-1 text-center text-xs text-red-500 font-medium">
                ⚠ Aktiva ≠ Pasiva! Razlika: {fmt(razlika)} EUR
              </td>
            </tr>
          )}
          {/* [PATCH razdeli-ddv-fe v1] napoved izida prenosa v VOD */}
          {ddvNaVoljo && vodStatus && (
            <tr>
              <td colSpan={(prikaziSm ? 7 : 6) + (prikaziProjekt ? 1 : 0)}
                  className={clsx('px-3 py-1 text-center text-xs font-medium',
                    vodStatus.ok ? 'text-green-600' : 'text-amber-600')}>
                {vodStatus.ok ? '✓ DDV parjenje za prenos je v redu'
                              : '⚠ Prenos bo padel: ' + vodStatus.razlog}
              </td>
            </tr>
          )}
        </tfoot>
      </table>
      {opisiKonto && <KontoBesedePopup companyId={companyId} konto={opisiKonto} onClose={() => setOpisiKonto(null)} />}{/* [PATCH_OPISI_KONTO_PLUS_V1] */}
    </div>
  );
}

// [PATCH placano-fe v1] mini iskalnik placnika (delavca) za "+ Placano" DOBRO vrstico.
// Function declaration je hoistana, zato je definicija na koncu datoteke veljavna.
function PlacnikVrstica({ partnerId, partnerNaziv, partnerji, onIzbira, placeholder, companyId }: {
  partnerId?: string; partnerNaziv?: string; partnerji: any[];
  onIzbira: (partner_id: string, partner_naziv: string) => void;
  placeholder?: string;  // [PATCH saldakonto-partner v1] privzeto ostane placnik (delavec)
  companyId?: string;    // [PATCH saldakonto-partner v2] za iskanje cez cel sifrant
}) {
  const [q, setQ] = useState<string | null>(null);
  const [open, setOpen] = useState(false);
  const [oddaljeni, setOddaljeni] = useState<any[]>([]); // [PATCH saldakonto-partner v2]
  const prikaz = q !== null ? q : (partnerNaziv || '');
  const lokalni = (q === null ? [] : partnerji.filter((p: any) =>
    (p.name || '').toLowerCase().includes(q.toLowerCase()) || (p.tax_number || '').includes(q))).slice(0, 8);
  // [PATCH saldakonto-partner v2] partnerjiSeznam je odrezan na 5000 (sifranti.py get_partnerji:
  // limit=200, strop min(max(limit,1),5000), sort po dolzini sifre). Pri velikih
  // sifrantih partnerja lokalno NI -> vprasaj streznik, ki isce cez cel sifrant.
  useEffect(() => {
    const niz = String(q || '').trim();
    if (!companyId || niz.length < 2) { setOddaljeni([]); return; }
    let veljaven = true;
    const t = setTimeout(() => {
      api.get(`/sifranti/partnerji/${companyId}?q=${encodeURIComponent(niz)}&limit=20`)
        .then(r => { if (veljaven) setOddaljeni(r.data || []); })
        .catch(() => { if (veljaven) setOddaljeni([]); });
    }, 300);
    return () => { veljaven = false; clearTimeout(t); };
  }, [q, companyId]);
  const vidni = new Set(lokalni.map((p: any) => String(p.id)));
  const filtered = lokalni.concat(oddaljeni.filter((p: any) => !vidni.has(String(p.id)))).slice(0, 8);
  return (
    <div className="relative mt-0.5">
      <input value={prikaz}
        onChange={e => { setQ(e.target.value); setOpen(true); }}
        onFocus={() => { setQ(''); setOpen(true); }}
        onBlur={() => setTimeout(() => { setQ(null); setOpen(false); }, 150)}
        placeholder={placeholder || "plačnik (delavec)..."}
        className={clsx('w-44 bg-gray-800 text-white text-xs rounded px-2 py-0.5 outline-none border', partnerId ? 'border-gray-600' : 'border-red-500')} />
      {open && filtered.length > 0 && (
        <div className="absolute left-0 top-6 w-72 bg-gray-900 border border-gray-700 rounded-xl shadow-2xl z-[9999] max-h-48 overflow-y-auto">
          {filtered.map((p: any) => (
            <button key={p.id} onMouseDown={() => { onIzbira(String(p.id), String(p.name || '')); setQ(null); setOpen(false); }}
              className="w-full text-left px-3 py-1.5 hover:bg-gray-800 flex gap-2">
              <span className="text-xs text-gray-300 truncate">{p.name}</span>
              <span className="text-[10px] text-gray-500 font-mono shrink-0">{p.tax_number || ''}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
